export default "__VITE_ASSET__BSocuju$__"